export default "__VITE_ASSET__CRJDqVUY__"